/** The `work` area: the Work page, and the list rail's arrangement vocabulary
 *  every lens reads (`src/app/work-view.ts`). Owned by the stage 2 slot views
 *  (docs/I18N.md §11). */
export const work = {
  // --- The Work page -----------------------------------------------------------
  'work.page.title': 'Work',
  'work.page.count': { one: '{count} item', other: '{count} items' },
  'work.page.empty': 'Nothing here yet.',
  'work.page.addFirst': 'Add first item',
  /** Under the empty Work when its own saved filter hides everything (the
   *  standard's party chip): clears the filter for a look. */
  'work.page.showAll': 'Show all',

  // --- The sorts (`WORK_SORT_LABEL`) ------------------------------------------
  'work.sort.touched': 'Last updated',
  'work.sort.changed': 'Last activity',
  'work.sort.viewed': 'Last viewed',
  'work.sort.created': 'Newest',
  'work.sort.priority': 'Priority',
  'work.sort.alpha': 'A–Z',

  // --- The groupings (`WORK_GROUP_LABEL`) -------------------------------------
  'work.group.flow': 'Flow',
  'work.group.stage': 'Stage',
  /** Group by the boards an item is on. */
  'work.group.view': 'Board',
  'work.group.parent': 'Parent',
  'work.group.tag': 'Tag',
  'work.group.priority': 'Priority',
  /** Group by the lens's own custom groups. */
  'work.group.custom': 'Custom',
  /** No grouping. */
  'work.group.none': 'No grouping',

  // --- The section headings the product names ---------------------------------
  'work.section.must': 'Must',
  'work.section.should': 'Should',
  'work.section.could': 'Could',
  'work.section.noPriority': 'No priority',
  'work.section.noParent': 'No parent',
  'work.section.noTag': 'No tag',
  'work.section.noView': 'Not on a board',
  'work.section.noFlow': 'No flow',
  /** The custom groups' remainder: rows no group takes. */
  'work.section.other': 'Other',
  /** A stage section: the flow's name, then the stage's word. */
  'work.section.flowStage': '{flow}: {stage}',
} as const;
